import Api from "@/services/Api";

export default {
  get(id) {
    return Api().get("apps/" + id + "/products");
  },

  getProduct(appId, productID) {
    return Api().get("apps/" + appId + "/products/" + productID);
  },

  update(appId, productID, payload) {
    return Api().put("apps/" + appId + "/products/" + productID, payload);
  },

  deleteProduct(appId, productID) {
    return Api().delete("apps/" + appId + "/products/" + productID);
  },

  create(id, payload) {
    return Api().post("apps/" + id + "/products", payload);
  },

  updatePricing(appId, productID, payload) {
    return Api().put("apps/" + appId + "/products/" + productID + "/pricing", payload);
  },

  getArtboard(productId) {
    return Api().get(`products/${productId}/artbord/`);
  },

  updateArtboard(productId, artboardId, payload) {
    return Api().put(`products/${productId}/artbord/${artboardId}`), payload;
  },

  deleteArtboard(productId, artboardId) {
    return Api().delete(`products/${productId}/artbord/${artboardId}`);
  },

  createArtboard(productId, payload) {
    return Api().post(`products/${productId}/artbord`, payload);
  },

  //FIELD ROUTES

  getFields(artboardId) {
    return Api().get(`artboard/${artboardId}/fields/`);
  },

  getField(artboardId, fieldId) {
    return Api().get(`artboard/${artboardId}/fields/${fieldId}`);
  },

  updateField(artboardId, fieldId, payload) {
    return Api().put(`artboard/${artboardId}/fields/${fieldId}`), payload;
  },

  deleteField(artboardId, fieldId) {
    return Api().delete(`artboard/${artboardId}/fields/${fieldId}`);
  },

  createField(artboardId, payload) {
    return Api().post(`artboard/${artboardId}/fields`, payload);
  },

  // GALLERY

  addGalleryAsset(appId, productId, assetId) {
    return Api().post(`apps/${appId}/products/${productId}/gallery`, { assetId: assetId });
  },

  deleteGalleryAsset(appId, productId, assetId) {
    return Api().delete(`apps/${appId}/products/${productId}/gallery/${assetId}`);
  },

  // CATEGORIES

  getAllProductCategories(appId) {
    return Api().get(`apps/${appId}/products/categories/`);
  },

  getProductCategory(appId, catId) {
    return Api().get(`apps/${appId}/products/categories/${catId}`);
  },

  getCategoryForProduct(appId, productId) {
    return Api().get(`apps/${appId}/products/categories/?productId=${productId}`);
  },

  createProductCategory(appId, name, description, assetId) {
    return Api().post(`apps/${appId}/products/categories/`, { name: name, description: description, assetId: assetId });
  },

  updateProductCategory(appId, catId, name, description, assetId) {
    return Api().put(`apps/${appId}/products/categories/${catId}`, { name: name, description: description, assetId: assetId });
  },

  deleteProductCategory(appId, catId) {
    return Api().delete(`apps/${appId}/products/categories/${catId}`);
  },

  addProduct2Category(appId, catId, productId) {
    return Api().post(`apps/${appId}/products/categories/${catId}/${productId}`);
  },

  deleteProduct2Category(appId, catId, productId) {
    return Api().delete(`apps/${appId}/products/categories/${catId}/${productId}`);
  }
};
